import { CollectorsDisplayState } from './display.types';

export const getDefaultDisplay = (): CollectorsDisplayState => ({
  isFiltersDialogOpen: false,
});

export const displayInitialState: CollectorsDisplayState = getDefaultDisplay();
